/**
 * MinMarksValidator class is responsible for validating if the total marks in the model
 * meet the minimum required marks as specified by the TaskInfoService.
 */
class MinMarksValidator {
    /**
     * Constructs a new MinMarksValidator instance.
     * @param {Object} model - The model containing the marks to be validated.
     * @param {Object} $injector - The injector service used to retrieve other services.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;

        this._TaskInfoService = null;
        this._translate = null;

        // Initialize the validation message using the translate service.
        this._message = this.getTranslate().instant('CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.MIN-MARKS', {
            'maxMarks': this.getTaskInfoService().getTaskInfo().getTotalMarks()
        });
        this._forced_check = true;
    }

    /**
     * Retrieves the TaskInfoService from the injector.
     * @returns {Object} The TaskInfoService instance.
     */
    getTaskInfoService() {
        if (!this._TaskInfoService) {
            this._TaskInfoService = this.$injector.get('TaskInfoService');
        }
        return this._TaskInfoService;
    }

    /**
     * Retrieves the translate service from the injector.
     * @returns {Object} The translate service instance.
     */
    getTranslate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model's total marks against the minimum required marks.
     * @param {Object} from - The source object triggering the validation.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let result = {};
        let error = false;

        // Check if the model's total marks are less than the required minimum.
        if (this.getTaskInfoService().getTaskInfo().getTotalMarks() > this.model.getTotalMarks()) {
            error = true;
        }

        // Prepare the validation result.
        result = {
            'onSheetBlur':  false,
            'onlyBanner':   false,
            'validator':    this.getValidatorName(),
            'modelUUID':    this.model.getUUID(),
            'error':        error,
            'status':       error ? 'WARNING' : 'SUCCESS', // WARNING | DANGER | SUCCESS
            'message':      this._message,
            'message_data': {
                'task_total_marks': this.getTaskInfoService().getTaskInfo().getTotalMarks(),
                'total_marks':      this.model.getTotalMarks()
            },
            'callbacks':    []
        };

        return result;
    }

    /**
     * Returns the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        return this._message;
    }

    /**
     * Indicates whether a forced check is required.
     * @returns {boolean} True if a forced check is required, otherwise false.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Returns the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'MinMarksValidator';
    }
}

export default MinMarksValidator;